export default "__VITE_ASSET__BpJc0pep__"